export default {
  name: 'partial-spinner',
  data () {
    return {
      
    }
  },
  methods: {
  },
  
  created() {
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/partialspinner/partialspinner.js